import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CustomersService } from 'src/app/services/customer.service';
import { CustomerInsightService } from '../service/customer-insight.service';

@Component({
  selector: 'kt-vist-metrics',
  templateUrl: './vist-metrics.component.html',
  styleUrls: ['./vist-metrics.component.css']
})
export class VistMetricsComponent implements OnInit {

  @Input() customerId: number;
  @Input() isFinancialYear: boolean=false;
  @Output() dataLoaded = new EventEmitter<void>(); // Event emitter for data load

  visitMetricsData: any;
  totalSuccessVisits: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  totalSuccessCalls: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  totalRosterPlan: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  UpcommingVisitData:any;
  recentVisit:any;
  mostObjectiveVisit: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  mostObjectiveCall: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  referralBusinessData: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  private loadingSubject = new BehaviorSubject<boolean>(true);
  loading$ = this.loadingSubject.asObservable().pipe(shareReplay(1));
  visitStatusCountLabel: any[]=[];
  visitStatusCountData: any[]=[];
  callStatusCountLabel: any[]=[];
  callStatusCountData: any[]=[];
  LastUpdatedSince: any;
  constructor(
    private customerService: CustomersService,
    private cdr: ChangeDetectorRef,
    private customerInsightService: CustomerInsightService,

  ) { }

  ngOnInit(): void {
    if (this.customerId && this.customerId > 0) {
      setTimeout(()=>{
        this.fetchVisitMetrics();
      },2500)
      
  
    }
  }

  ngOnChanges(changes: SimpleChanges) {
	}

  initializeData(){
  this.visitMetricsData=[];
  this.totalSuccessVisits={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  this.totalSuccessCalls={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  this.totalRosterPlan={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  this.UpcommingVisitData=[];
  this.recentVisit=[];
  this.mostObjectiveVisit={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  this.mostObjectiveCall={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  this.referralBusinessData={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  this.visitStatusCountLabel=[];
  this.visitStatusCountData=[];
  this.callStatusCountLabel=[];
  this.callStatusCountData=[];
  this.LastUpdatedSince=[]
  }
  fetchVisitMetrics():void{
    this.loadingSubject.next(true);
    this.initializeData();
    this.customerService.getVisitMetrics(this.customerId,this.isFinancialYear).subscribe({
      next:(res:any)=>{
        this.visitMetricsData = res.data;
        this.loadingSubject.next(false);
        this.LastUpdatedSince = (this.visitMetricsData && this.visitMetricsData.LastUpdatedSince) ? this.visitMetricsData.LastUpdatedSince[0]: undefined;
        if(this.visitMetricsData){
          this.transformVisitsAndCalls(res && res.data ? res.data.VisitCount : undefined,res && res.data ? res.data.CallCount : undefined);
          this.transformRosterCount(res && res.data ? res.data.RosterCount : undefined)
          this.transformObjectiveVisitAndCall(
            this.visitMetricsData && this.visitMetricsData.VisitObjectiveTotalCount 
              ? this.visitMetricsData.VisitObjectiveTotalCount 
              : undefined,
          
            this.visitMetricsData && this.visitMetricsData.CallObjectiveTotalCount 
              ? this.visitMetricsData.CallObjectiveTotalCount 
              : undefined
          );
          
          this.transformCallCount(res.data.CallLogStatusCount);
          this.transformVisitCount(res.data.VisitStatusCount)
          this.UpcommingVisitData = this.visitMetricsData ? this.visitMetricsData.UpcommingVisitDetails : undefined;
          this.recentVisit = this.visitMetricsData && this.visitMetricsData.LatestVisitsDetails ? this.visitMetricsData.LatestVisitsDetails : undefined;
          this.dataLoaded.emit()
        }
        
      },
      error:()=>{
        this.loadingSubject.next(false);
        this.dataLoaded.emit()
      }
    })
  }

  transformVisitsAndCalls(visitData:any,callData:any){
    let callLabels:any[]=[]
    let visitLabels:any[]=[]
    let visit:any[]=[]
    let successVisit:any[]=[]
    let call:any[]=[]
    let successCall:any[]=[]
    if (visitData && Array.isArray(visitData)) {
      visitData.forEach((res: any) => {
        visitLabels.push(res && res.Year ? res.Year : null);
        visit.push(res && res.TotalVisits ? res.TotalVisits : 0);
        successVisit.push(res && res.SuccessVisits ? res.SuccessVisits : 0);
      });
    }    
    if (Array.isArray(callData)) {
      callData.forEach((res: any) => {
        callLabels.push(res && res.Year ? res.Year : null);
        call.push(res && res.TotalCalls ? res.TotalCalls : 0);
        successCall.push(res && res.SuccessCalls ? res.SuccessCalls : 0);
      });
    }    

    this.totalSuccessVisits.labels = visitLabels 
    this.totalSuccessCalls.labels = callLabels

    this.totalSuccessVisits.data = [
      {
        data: visit,
        label: 'Visit',
        color: '#0095ff',
      },
      {
        data: successVisit,
        label: 'Success',
        color: '#00e096',
      }
    ]
    this.totalSuccessCalls.data = [
      {
        data: call,
        label: 'Call',
        color: '#0095ff'
      },
      {
        data: successCall,
        label: 'Success',
        color: '#00e096',
      }
    ]

  }

  transformRosterCount(data:any){
    let labels:any[]=[]
    let Planned:any[]=[]
    let Visited:any[]=[]

    if (Array.isArray(data)) {
      data.forEach((res: any) => {
        labels.push(res && res.Year ? res.Year : null);
        Planned.push(res && res.TotalRosterPlanned ? res.TotalRosterPlanned : 0);
        Visited.push(res && res.TotalRosterPlannedVisited ? res.TotalRosterPlannedVisited : 0);
      });
    }
    this.totalRosterPlan.labels = labels

    this.totalRosterPlan.data = [
      {
        data: Planned,
        label: 'Planned',
        color: '#0095ff'
      },
      {
        data: Visited,
        label: 'Visited',
        color: '#00e096',
      }
    ]

  }

  transformObjectiveVisitAndCall(visitData:any,callData:any){
    let formattedCallData = Array.isArray(callData) 
    ? callData.reduce((acc: any, item: any) => {
        acc[item.VisitCallPurpose] = item.CallPurposeCount;
        return acc;
      }, {}) 
    : {};
  
  let formattedVisitData = Array.isArray(visitData) 
    ? visitData.reduce((acc: any, item: any) => {
        acc[item.VisitCallPurpose] = item.VisitPurposeCount;
        return acc;
      }, {}) 
    : {};  

    if (formattedCallData) {
      this.mostObjectiveCall.labels = Object.keys(formattedCallData);
      this.mostObjectiveCall.data = [{
        data: Object.values(formattedCallData), // Single dataset for the chart
        color: this.customerInsightService.generateBlueShades(
          this.mostObjectiveCall.labels ? this.mostObjectiveCall.labels.length : 0
        )
      }];
    }
    
    if (formattedVisitData) {
      this.mostObjectiveVisit.labels = Object.keys(formattedVisitData);
      this.mostObjectiveVisit.data = [{
        data: Object.values(formattedVisitData), // Single dataset for the chart
        color: this.customerInsightService.generateBlueShades(
          this.mostObjectiveVisit.labels ? this.mostObjectiveVisit.labels.length : 0
        )
      }];
    }    
    
  }
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  transformReferralBusiness(data:any){
    this.referralBusinessData.labels = ['Total Business','Total Amount','Reward'];
    this.referralBusinessData.data=[
      {
        data: [data.TotalBusiness,data.TotalTransactionValue,data.TotalReferralReward],
        color: ['#0095ff','#07dbfa','#00e096']
      }
    ]
  }

  transformVisitCount(data:any){
    data.forEach((res:any)=>{
      this.visitStatusCountLabel.push(`${res.StatusName} (${res.VisitCount})`)
      this.visitStatusCountData.push(res.VisitCount)
    })
  }

  transformCallCount(data:any){
    data.forEach((res:any)=>{
      this.callStatusCountLabel.push(`${res.StatusName} (${res.CallCount})`)
      this.callStatusCountData.push(res.CallCount)
    })
  }
  
  // generateColorPalette(length: number): string[] {
  //   if (length <= 0) {
  //     return [];
  //   }
  
  //   const colors: string[] = [];
  //   const saturation = 80; // Keep saturation consistent for vibrancy
  //   const lightness = 70;  // Adjust for balanced brightness
  
  //   for (let i = 0; i < length; i++) {
  //     const hue = (360 / length) * i; // Evenly spaced hues
  //     colors.push(this.hslToHex(hue, saturation, lightness));
  //   }
  
  //   return colors;
  // }
  
  // // Helper function to convert HSL to HEX
  // hslToHex(h: number, s: number, l: number): string {
  //   s /= 100;
  //   l /= 100;
  
  //   const c = (1 - Math.abs(2 * l - 1)) * s;
  //   const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  //   const m = l - c / 2;
  
  //   let r = 0, g = 0, b = 0;
  
  //   if (h >= 0 && h < 60) {
  //     r = c; g = x; b = 0;
  //   } else if (h >= 60 && h < 120) {
  //     r = x; g = c; b = 0;
  //   } else if (h >= 120 && h < 180) {
  //     r = 0; g = c; b = x;
  //   } else if (h >= 180 && h < 240) {
  //     r = 0; g = x; b = c;
  //   } else if (h >= 240 && h < 300) {
  //     r = x; g = 0; b = c;
  //   } else if (h >= 300 && h < 360) {
  //     r = c; g = 0; b = x;
  //   }
  
  //   r = Math.round((r + m) * 255);
  //   g = Math.round((g + m) * 255);
  //   b = Math.round((b + m) * 255);
  
  //   return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  // }

  getStatusClass(statusName: string): string {
    switch (statusName) {
      case 'Success':
        return 'status-success';
      case 'Warm':
        return 'status-warm';
      case 'Cold':
        return 'status-cold';
      case 'Other':
        return 'status-other';
      case 'Hot':
        return 'status-hot';
      case 'Not Interested':
        return 'status-not-interested';
      default:
        return 'status-default'; // For unknown or empty statuses
    }
  }  

}
